import { ROLE_LABEL } from "../templates.js";
import { t, roleLabel, LangSwitch, LogOutIcon, BellIcon, KeyIcon, MadeByBadge } from "../i18n.jsx";

export default function Shell({ user, tab, onTab, onLogout, lang, onLangChange, children }) {
  const tabs = [{ key: "documente", label: "Documente" }];
  if (user.role !== "CLIENT_REVIEWER") {
    tabs.push({ key: "clienti", label: "Clienți & Situri" }, { key: "procese", label: "Registre" });
  }
  if (user.role === "OWNER") tabs.push({ key: "utilizatori", label: "Utilizatori" });

  return (
    <>
      <div className="topbar">
        <div className="brand">
          <span className="mark">S</span>
          SOP Management
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "1.2em" }}>
          <MadeByBadge lang={lang} />
          <span className="pill">{user.fullName} · {roleLabel(user.role, lang, ROLE_LABEL)}</span>
          <div className="topbar-actions">
            <LangSwitch lang={lang} onChange={onLangChange} />
            <button type="button" className="topbar-icon-btn" title={t(lang, "Notificări")}>
              <BellIcon size={15} />
            </button>
            <button type="button" className="topbar-icon-btn">
              <KeyIcon size={15} /> {t(lang, "Securitate cont")}
            </button>
            <button type="button" className="topbar-icon-btn" onClick={onLogout}>
              <LogOutIcon size={15} /> {t(lang, "Ieșire")}
            </button>
          </div>
        </div>
      </div>
      <div className="tabs">
        {tabs.map((tb) => (
          <button key={tb.key} className={`tab ${tab === tb.key ? "active" : ""}`} onClick={() => onTab(tb.key)}>
            {t(lang, tb.label)}
          </button>
        ))}
      </div>
      <main>{children}</main>
    </>
  );
}
